import api from "@/app/_module/services/api";
import { getApiUrl } from "@/app/_module/services/config";
import { endpoint } from "@/app/_module/services/endpoints";

export type PlatformAnnouncementSeverity = "info" | "warning" | "critical";

export interface ActivePlatformAnnouncement {
  id: string;
  title: string;
  body: string;
  severity: PlatformAnnouncementSeverity;
  ctaLabel: string | null;
  ctaUrl: string | null;
  isDismissible: boolean;
  createdAt: string;
}

function unwrap<T>(resp: any): T {
  const outer = (resp as any)?.data ?? resp;
  return (outer?.data ?? outer) as T;
}

export const getActivePlatformAnnouncements = async (): Promise<ActivePlatformAnnouncement[]> => {
  try {
    const resp = await api.get({
      url: getApiUrl(endpoint.platformAnnouncements.active),
      auth: true,
    });
    return unwrap<ActivePlatformAnnouncement[]>(resp) || [];
  } catch {
    // Banner is best-effort — never break the page if the endpoint hiccups.
    return [];
  }
};

export const dismissPlatformAnnouncement = async (id: string): Promise<void> => {
  try {
    await api.post({
      url: getApiUrl(endpoint.platformAnnouncements.dismiss(id)),
      auth: true,
    });
  } catch {
    // Swallow — UI already optimistically hid the banner.
  }
};
